import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { api, absUrl, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function UploadInput({ value, onChange, testId, placeholder = "Paste URL or upload…" }) {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const pick = () => inputRef.current?.click();
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(absUrl(data.url));
      toast.success("Uploaded");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const clear = () => onChange("");
  return (
    <div>
      <div className="flex gap-2">
        <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId}
          className="flex-1 rounded-md border border-gold-light bg-white px-3 py-2 text-sm" />
        <button type="button" onClick={pick} disabled={busy}
          className="btn-outline !py-2 !px-3 text-xs" data-testid={`${testId}-upload`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          Upload
        </button>
        {value && (
          <button type="button" onClick={clear} className="text-charcoal/50 hover:text-burgundy" title="Clear">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" hidden onChange={upload} accept="image/*,application/pdf" />
      {value && (
        <div className="mt-2">
          {/\.(png|jpg|jpeg|webp|gif)$/i.test(value) || value.includes("http") ? (
            <img src={value} alt="preview" className="h-16 w-24 object-cover rounded border border-gold-light" onError={(ev) => ev.target.style.display = 'none'} />
          ) : null}
        </div>
      )}
    </div>
  );
}
